import React, { useEffect } from 'react';

const WorkoutInfo = () => {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
    return (
        <div className="w-full h-fit py-12">
            <div className="mxw">
                <p className="pb-6 text-md md:text-lg lg:text-xl">Let us use your workout info to give you, features like:</p>
                <ul className="text-md md:text-lg lg:text-xl space-y-1">
                    <li>Consectetur adipisicing elit maxime mollitia, molestiae quas vel sint adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi.</li>
                    <li>Maxime mollitia, molestiae quas vel sint commodi  sit amet consectetur adipisicing amet.</li>
                    <li>Quas vel sint commodi lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi.</li>
                </ul>
                <p className="pt-6 text-md md:text-lg lg:text-xl">Impedit sit sunt quaerat, odit, tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit, quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam recusandae alias error harum maxime adipisci amet laborum.</p>
                <div className="mt-6 w-full h-fit py-4 border-t border-b border-gray-700 flex items-center justify-between">
                    <p className="font-semibold">Use My Workout Info</p>
                    <div className="px-3">
                        <input className="scale-150" type="checkbox" />
                    </div>  
                </div>
            </div>
        </div>
    );
}

export default WorkoutInfo;
